import AnalyticsEvents_V2 from '../analyticsGA4'
import { PortalProducts } from '../types/analytics.type'

import { ChecklistEvents } from './checklistEvents.types'

class checklistAnalytics extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.CHECKLIST)
  }

  public logChecklistExpanded(): void {
    this.logEvent({ event: ChecklistEvents.CHECKLIST_EXPANDED })
  }

  public logChecklistItemCompleted(feature: string): void {
    this.logEvent({ event: `${ChecklistEvents.COMPLETED_CHECKLIST_ITEM}_${feature}` })
  }

  public logChecklistCompleted(): void {
    this.logEvent({ event: ChecklistEvents.CHECKLIST_COMPLETED })
  }

  public logChecklistRewardClaim(xp: number): void {
    this.logRewards({
      title: ChecklistEvents.CHECKLIST_COMPLETED_TITLE,
      gems: 0,
      experience_points: xp,
      kudos: 0,
    })
  }
}

export default new checklistAnalytics()
